var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "flickity",
    {
      ref: "flickity",
      staticClass: "carousel",
      class: {
        bottom: _vm.bottomArrows,
        alternatecolor: _vm.alternateArrowColor,
        loading: !_vm.initialized,
        nodots: !_vm.showDots,
        noarrows: !_vm.showArrows,
        "is-grouped": _vm.groupCells > 1
      },
      attrs: { options: _vm.flickityOptions, "aria-label": _vm.ariaLabel }
    },
    [_vm._t("default", null, { next: _vm.next, previous: _vm.previous })],
    2
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4072fe16", { render: render, staticRenderFns: staticRenderFns })
  }
}